import angular from 'angular';
import { ACCOUNT_EDITED, PASSWORD_CHANGED } from 'common/messages';
import templateUrl from './account.html';

export default {
  templateUrl,
  bindings: {
    accessLevels: '<',
    user: '<'
  },
  controller: class AccountComponent {
    constructor($mdDialog, $scope, $state, AccountService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        AccountService,
        ToastService
      });
    }

    updateAccount($event) {
      if ($event && $event.user) {
        this.AccountService.updateAccount($event.user)
          .then(() => {
            this.ToastService.showSuccess(ACCOUNT_EDITED);
            this.$state.reload();
          }).catch(error => this.ToastService.showError(error));
      }
    }

    showChangePassword() {
      const scope = angular.extend(this.$scope.$new(true), {
        passwordChanged: $event => this.onPasswordChanged($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <change-password password-changed="passwordChanged($event)">
              </change-password>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onPasswordChanged($event) {
      if ($event && $event.credentials && this.user.UserId) {
        this.AccountService.forcePasswordChange({
          UserId: this.user.UserId,
          ...$event.credentials
        }).then(() => {
          this.$mdDialog.hide();
          this.ToastService.showSuccess(PASSWORD_CHANGED);
        }).catch(error => this.ToastService.showError(error));
      }
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/account/account.component.js